const Y = f => (...args) => f(Y(f))(...args);

export default Y;



// WEBPACK FOOTER //
// ./node_modules/@triotech/vue-core/src/lib/helper/y.js